import { all, takeLatest } from 'lib/redux';
import {
  FETCH_ADDRESS, GET_DUPLICATE_REPORTS, LOAD_ORDER_PAGE,
  ORDER_PAGE_UPLOAD_BLUEPRINT_FILE,
  UPDATE_SELECTED_PRODUCT,
  CHECK_IMAGE_COVERAGE,
  DELETE_MAP_POINT_ACTION,
  UPDATE_MAP_POINT_ADDRESS_ACTION,
  UPDATE_MAP_POINT_LOCATION_ACTION,
  ADD_MAP_POINT,
  FETCH_PIN_ADDRESS,
  PROPERTY_DATA_REQUEST,
  PROPERTY_DATA_RESULT,
  SUBSCRIPTION_DASHBOARD_SUCCESS,
  USER_PRODUCTS_SUCCESS,
} from 'constants/ActionTypes';
import {
  getDuplicateReportsSaga, getGeocodeSaga, loadOrderPageSaga, updateSelectedProductsSaga,
  uploadBlueprintFileSaga,
  checkImageCoverageSaga,
  deleteMapPointSaga,
  updateMapPointAddressSaga,
  updateMapPointLocationSaga,
  addPinSaga,
  fetchAndUpdatePinAddressSaga,
  mergePrimarySubscriptionProductsSaga,
} from './Order.saga';
import { propertyDataRequestSaga, propertyDataResultSaga } from './PropertyData.saga';
/**
 * Defines the watchers related to Order Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(FETCH_ADDRESS, getGeocodeSaga),
    takeLatest(LOAD_ORDER_PAGE, loadOrderPageSaga),
    takeLatest(GET_DUPLICATE_REPORTS, getDuplicateReportsSaga),
    takeLatest(UPDATE_SELECTED_PRODUCT, updateSelectedProductsSaga),
    takeLatest(ORDER_PAGE_UPLOAD_BLUEPRINT_FILE, uploadBlueprintFileSaga),
    takeLatest(CHECK_IMAGE_COVERAGE, checkImageCoverageSaga),
    takeLatest(DELETE_MAP_POINT_ACTION, deleteMapPointSaga),
    takeLatest(UPDATE_MAP_POINT_ADDRESS_ACTION, updateMapPointAddressSaga),
    takeLatest(UPDATE_MAP_POINT_LOCATION_ACTION, updateMapPointLocationSaga),
    takeLatest(ADD_MAP_POINT, addPinSaga),
    takeLatest(FETCH_PIN_ADDRESS, fetchAndUpdatePinAddressSaga),
    takeLatest(PROPERTY_DATA_REQUEST, propertyDataRequestSaga),
    takeLatest(PROPERTY_DATA_RESULT, propertyDataResultSaga),
    takeLatest(SUBSCRIPTION_DASHBOARD_SUCCESS, mergePrimarySubscriptionProductsSaga),
    takeLatest(USER_PRODUCTS_SUCCESS, mergePrimarySubscriptionProductsSaga),
    takeLatest(LOAD_ORDER_PAGE, mergePrimarySubscriptionProductsSaga),
  ]);
}
